import type {
  AccountType,
  CheckClassification,
  ClassificationMetadataCancellationTypeEnum,
  CustomerFundsClassification,
  FinancialInstitutions,
  ReconciledType,
  ReconciliationStatus,
  ReconDetailsBankRecord,
  ReconDetailsCardCostRecord,
  ReconDetailsCardRecord,
  RevenueAccountsClassification
} from '@melio/payments-recon-api-client-ts';
import { Moment } from '@tools/ui/types';
import { t } from '@tools/ui-utils/translate.util';
import { reconEnumValue } from '../utils/reconEnumValue';

export enum DeliveryType {
  Bank = 'bank',
  Card = 'card'
}

export type recoFilters = {
  to: string | Moment;
  from: string | Moment;
  recordType: DeliveryType;
  bankRecordType: Array<string>;
  reconciledType?: ReconciledType;
  reconciliationStatus?: ReconciliationStatus;
  classification?: Array<
    | CheckClassification
    | CustomerFundsClassification
    | RevenueAccountsClassification
  >;
  cancellationType?: Array<ClassificationMetadataCancellationTypeEnum>;
  accountType: AccountType;
  financialInstitution?: FinancialInstitutions;
  fromAmount?: number;
  toAmount?: number;
  mid?: Array<string>;
};

export type RecordDetails =
  | ReconDetailsBankRecord
  | ReconDetailsCardRecord
  | ReconDetailsCardCostRecord;

export const PAGE_SIZE_OPTIONS = ['15', '30', '50', '100', '200', '400'];

export const INIT_PAGE_NUMBER = 1;

export const BOTTOM_LIMIT_RANGE = 15;

export const TOP_LIMIT_RANGE = 100;

export const TRANSFERS_PANEL_QUERY_PARAM_TRIGGER = 'transfersPanel';
export const RECORD_PANEL_QUERY_PARAM_TRIGGER = 'ambiguousRecordId';

export const RECO_DAILY_BALANCE_ASSIGNEES_LIST = [
  'Fanni Palko',
  'Leanne Sassi',
  'Nataly Kravetz',
  'Adrian Son',
  'Gili Gershon',
  'Bernard McGrane'
];

export enum DailyBalanceStatus {
  InProgress = 'inProgress',
  Done = 'done',
  Blocked = 'blocked'
}

export const RECO_FEEDBACK_CHANNEL = 'C090S0PDC7L';

export const SPECIAL_VENDOR_IDS = {
  '0': '0000 - MicroDeposits',
  '-2': '0002 - Other',
  '-3': '0003 - Duplicate ACH transactions release May 17th/Technical solution in progress',
  '-4': '0004 - Amex misplaced fees',
  '-5': '0005 - Amex chargeback error',
  '-6': '0006 - MID 117339 Debt',
  '-7': '0007 - Evolve - JPM',
  '-8': '0008 - Melio',
  '-9': '0009 - Other Under Investigation'
};

export const financialInstitutionOptions = [
  {
    label: t('reco.banks.jpm'),
    value: reconEnumValue<FinancialInstitutions>('jpm')
  },
  {
    label: t('reco.banks.svb'),
    value: reconEnumValue<FinancialInstitutions>('svb')
  },
  {
    label: t('reco.banks.evolve'),
    value: reconEnumValue<FinancialInstitutions>('evolve')
  }
];
